import React from 'react';
import PropTypes from 'prop-types';

const RadioButtonInput = (props) => {
  const handleChange = () => {
    props.onChange(props.name,
      props.value);
  };
  /* eslint-disable no-unused-vars */
  const {onChange, ...properties} = props;
  /* eslint-enable no-unused-vars */
  return (
    <input
      onChange={handleChange}
      type="radio"
      {...properties}
    />
  );
};

RadioButtonInput.PropTypes = {
  value:PropTypes.oneOfType([PropTypes.string,PropTypes.number,PropTypes.bool]).isRequired,
  onChange:PropTypes.func.isRequired,
  checked:PropTypes.bool.isRequired,
  name:PropTypes.string.isRequired,
};

export default RadioButtonInput;
